

<div class="address_book address_modal tab_content" id="content8" data-tab="8" style="position:relative;">







  <div class="acquisition_top" style="display:block; margin-bottom: 1rem;" >
    <!-- top left part  -->

  <h2 class="heading">Damage List<span class="ti-close" (click)="onClose()" style="cursor: pointer;"></span></h2>
    <!-- top right part -->

    <div class="filter_search">
      <div class="search_container">
        <input type="text"  #search class="default_input search search_land" placeholder="Search" />
        <i class="ti-search"></i>
      </div>

      <span class=" filter"><mat-checkbox (change)="OnChange($event)"></mat-checkbox> View All</span>

    </div>

  </div>



  <div class="card mt-3 ">
    <div class="table-responsive" >
    <table class="table table-hover" >
      <thead>
        <tr>
          <th scope="col">S/N</th>
          <th scope="col">Item Name</th>
          <th scope="col">Company Approved Rate</th>
          <th scope="col">Opt Approved Rate</th>
          <th scope="col">Measure</th>
          <th scope="col">Remark</th>
        </tr>
      </thead>
      <tbody >
        <tr *ngFor="let item of (itemList$ | async); index as i" (click)="onView(item)" style="cursor: pointer;"
        >
          <th scope="row">{{i + 1}}</th>
          <td>{{ item?.ItemName }}</td>
          <td>{{ item?.CompanyApprovedRate }}</td>
          <td> {{ item?.OptApprovedRate }}</td>
          <td>{{getMeasureName(item?.MeasureId)}}</td>
          <td>{{item?.Remark}}</td>
        </tr>

      </tbody>
    </table>
  </div>
  </div>
  </div>

  <cradua-list-spinner
  *ngIf="(isLoadingDamageList$ | async) === true"
  >
  </cradua-list-spinner>
  <!-- <pre>{{addressBook$ | async | json}}</pre> -->
